export default {"src":"/_next/static/media/nbc-golf.d79aaf2e.svg","height":32,"width":161,"blurWidth":0,"blurHeight":0};